const deleteWeekReservation = (state, action) => {
  const { locationWeekId } = action

  return state.filter(wr => wr.locationWeekId !== locationWeekId)
}

export default deleteWeekReservation
